<template>
  <v-card height="100%" v-once>
    <v-card-title primary-title>
      <div class="headline">{{title}}</div>
    </v-card-title>
    <template v-if="query.mtrPlan">
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs6>
              <v-subheader class="queryLabel">Plan</v-subheader>
            </v-flex>
            <v-flex xs6>{{query.mtrPlan}}</v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
    </template>
    <v-card-title v-if="bothModule">
      <div class="body-2">{{labels.stats}}</div>
    </v-card-title>
    <template v-if="statistics">
      <v-card-text v-if="statisticsList.length > 0">
        <v-container fluid grid-list-lg>
          <v-layout row wrap v-for="(stats, i) in statisticsList" :key="i">
            <v-flex xs6>
              <v-subheader class="queryLabel">{{stats.key}}</v-subheader>
            </v-flex>
            <v-flex xs6>{{stats.value}}</v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-text v-else>
        No Statistic Found
      </v-card-text>
    </template>
    <v-divider v-if="bothModule"></v-divider>
    <v-card-title v-if="bothModule">
      <div class="body-2">{{labels.excess}}</div>
    </v-card-title>
    <template v-if="excess">
      <v-card-text v-if="excessList.length > 0">
        <v-container fluid grid-list-lg>
          <v-layout row wrap v-for="(excess, i) in excessList" :key="i">
            <v-flex xs6>
              <v-subheader class="queryLabel">{{excess.key}}</v-subheader>
            </v-flex>
            <v-flex xs6>{{$store.state.agency.quotation.commonInfo.currPrefix}}{{formatDisplayNumber(excess.value)}}</v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-text v-else>
        No Excess Found
      </v-card-text>
    </template>
  </v-card>
</template>

<script>
import { formatDisplayNumber } from '@/utils/number'
export default {
  data() {
    return {
      labels: {
        excessStats: 'Excess/Statistics',
        excess: 'Excess',
        stats: 'Statistics'
      }
    }
  },
  computed: {
    title() {
      if (this.excess && this.statistics) {
        return this.labels.excessStats
      } else if (this.excess) {
        return this.labels.excess
      } else if (this.statistics) {
        return this.labels.stats
      }
      return ''
    },
    bothModule() {
      if (this.excess && this.statistics) {
        return true
      } else {
        return false
      }
    },
    query() {
      return this.$store.state.agency.quotation.queryInfo
    },
    excessList() {
      return this.query.excess
    },
    statisticsList() {
      return this.query.statistics
    }
  },
  methods: {
    formatDisplayNumber(xNum) {
      return formatDisplayNumber(xNum)
    }
  },
  props: {
    excess: {
      type: Boolean,
      default: true
    },
    statistics: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss">

</style>
